"use client";
import React from "react";

const CityTitle = ({ isMobile, topNeighborhood, stateName }) => {
  if (!topNeighborhood || topNeighborhood.length === 0) return null;

  const cityDisplay = `${topNeighborhood[0].postalcity_name}, ${stateName}`;

  return (
    <>
      {isMobile ? (
        <div className="nh_title_main_print">
          <span className="nh_title_print">{cityDisplay}</span>
        </div>
      ) : (
        <div className="nh_title_city">
          <span className="nh_title_left">{cityDisplay}</span>
        </div>
      )}
    </>
  );
};

export default CityTitle;
